import service from "./lib/service";

// 手机号注册
export const phoneSignup = (data) =>
  service({ url: "/account-admin/revise/phoneSignup", method: "post", data });

// 获取手机验证码
export const phoneCaptcha = (data) =>
  service({ url: "/account-admin/revise/phoneCaptcha", method: "post", data });

// 账号登录
export const accountLogin = (data) =>
  service({ url: "/account-admin/login/login", method: "post", data });

// 短信登录
export const phontLogin = (data) =>
  service({ url: "/account-admin/login/phone", method: "post", data });

// 退出登录 禁用token
export const logout = () =>
  service({ url: "sso/api/sso/web/discardToken", method: "get" });

// 获取用户信息
export const getUserInfo = data => service({ url: "/account-admin/revise/getUserInfo", method: "post", data })

// 修改密码
export const resetPsw = (data) =>
  service({
    url: "/account-admin/revise/updatePassword",
    method: "post",
    data,
  });

//生成图片验证码坐标
export const createImageAuthCode = (data) =>
  service({ url: "/account-admin/login/imageCode", method: "post", data });

//效验验证码坐标
export const checkoutImageAuthCode = (data) =>
  service({
    url: "/account-admin/login/imageCode/check",
    method: "post",
    data,
  });

// 更换手机号旧手机号验证
export const checkPhone = (data) =>
  service({
    url: "/account-admin/revise/updatePhone/check",
    method: "post",
    data,
  });

// 更换手机号
export const updatePhone = (data) =>
  service({ url: "/account-admin/revise/updatePhone", method: "post", data });

// 绑定手机号
export const bindPhone = (data) =>
  service({ url: "/account-admin/revise/phoneBinding", method: "post", data });

// 绑定邮箱
export const bingMail = (data) =>
  service({ url: "/account-admin/revise/bindingMail", method: "post", data });

// 修改邮箱
export const updateMail = (data) =>
  service({ url: "/account-admin/revise/updateMail", method: "post", data });

// 获取邮箱验证码
export const getMailCode = (data) =>
  service({ url: "/account-admin/revise/mailCaptcha", method: "post", data });

// 修改邮箱旧邮箱验证
export const checkMail = (data) =>
  service({
    url: "/account-admin/revise/updateMail/check",
    method: "post",
    data,
  });

// 创建个人空间
export const createSpace = (data) =>
  service({ url: "/user-service/user/createPersonSpace", method: "post", data });

// 获取用户主体信息
export const getUserBody = (data) =>
  service({ url: "/user-service/user/getUserPrincipal", method: "post", data });

// 根据主体获取token
export const getBodyToToken = (data) =>
  service({ url: "/account-admin/login/getToken", method: "post", data });

// 更新用户信息
export const updateUserInfo = (data) =>
  service({ url: "/account-admin/revise/updateUser", method: "post", data });

// 微信绑定
export const weixinBind = (data) =>
  service({
    url: "/account-admin/wechat/binding/callback?code=" + data,
    method: "post",
  });

// 微信登录验证
export const weixinLoginCheck = (data) =>
  service({ url: "/account-admin/wechat/callback", method: "post", data });

// 确定绑定微信
export const confirmBindWeixin = (data) =>
  service({
    url: "/account-admin/wechat/binding?wechatKey=" + data,
    method: "post",
  });

// 微信绑定登录
export const loginBindWeixing = (data) =>
  service({
    url: "/account-admin/revise/loginPhoneBinding",
    method: "post",
    data,
  });

// 微信解绑
export const unbingWeixin = (data) =>
  service({ url: "/account-admin/wechat/unbinding", method: "post", data });

// 版权
export const uploadOSS = () => service({ url: "/user-service/aliyun/oss/policy", method: "get" });

// 批量获取字典
export const getByKeys = data => service({ url: "/account-search/basic/dict/getByKeys", method: "post", data });

// 地区接口
export const getCityList = data => service({ url: "/account-search/basic/city/list", method: "post", data });

// 保存租户关注的各项信息
export const saveInformation = data => service({ url: "/user-service/org/focus/save", method: "post", data });

// 新切换主体
export const switchBody = data => service({ url: "/account-admin/revise/switchWorkspace", method: 'post', data });

// 登录后获取供应链token
export const getProductToken = () => service({ url: "/account-admin/login/product", method: "post" });

// 判断是否是老用户
export const getIsOldUser = () => service({ url: '/user-service/user/isOldUser', method: 'post' });


// 获取微信（公众号）二维码
export const getWechatQrcode = () => service({ url: `/account-admin/wechat/qrcode?type=login`, method: 'get' });

// 获取微信（公众号）二维码
export const getWechatQrcode2 = () => service({ url: `/account-admin/wechat/qrcode?type=binding`, method: 'get' });

// 微信公众号扫码登录轮询
export const wechatPolling = data => service({ url: "/account-admin/wechat/polling", method: "post", data });

// 微信公众号扫码登录轮询2
export const appBinding = data => service({ url: `/account-admin/wechat/appBinding?wechatKey=${data}`, method: "post" });

// 微信公众号扫码注册登录手机号绑定
export const loginPhoneBinding = data => service({ url: "/account-admin/wechat/loginPhoneBinding", method: "post", data });

// 当前用户信息
export const myInfo = (data) => service({ url: "/user-service/user/getMyInfo", method: "post", data });

// 校验链接是否过期
export const checkLinkUrl = (data) => service({ url: "/user-service/employee/checkLinkUrl", method: "post", data });

// 成员邀请登录
export const employeeLogin = (data) => service({ url: "/account-admin/login/employeeLogin", method: "post", data });